import React from "react";
import SampleAadharPopup from "./SampleAadharPopup";

export interface ISampleAadharMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

// Mobile uses the same centred modal (single column, internal scroll) as
// desktop instead of a bottom sheet.
const SampleAadharMobileViewProps = (props: ISampleAadharMobileViewProps) => (
  <SampleAadharPopup showPopup={props.showPopup} setShowPopup={props.setShowPopup} />
);
export default SampleAadharMobileViewProps;
